import {
    createContext,
    useContext,
    useReducer,
} from 'react';

export const LiveScoreContext = createContext(null);

export const useLiveScoreContext = () => {
    return useContext(LiveScoreContext);
};

export const LiveScoreProvider = ({ children }) => {
    const LiveScoreState = { openSelectLeaugePopup: false };
    const LiveScoreReducer = (state, action) => {
        switch (action.type) {
        case 'SHOW_SELECT_LEAGUE_POPUP':
            return { ...LiveScoreState, openSelectLeaugePopup: !state.openSelectLeaugePopup };
        default:
            return LiveScoreState;
        }
    };
    const [state, dispatch] = useReducer(
        LiveScoreReducer,
        LiveScoreState,
    );
    return (
        <LiveScoreContext.Provider value={[state, dispatch]}>
            {children}
        </LiveScoreContext.Provider>
    );
};
